import CommonUiModel from "../common/commonUiModel";

const NewHistoryModel = new CommonUiModel({
    title: "SecurityModLogRecordDetails",
    linkColumn: "ColumnName",
    idProperty: 'ModDetailId',
    navigateBack: true, //needed for back button
    readOnly: true,
    defaultSort: "ModDetailId desc",
    module: null,
    addCreatedOnColumn: false,
    addCreatedByColumn: false,
    enableGoBack: true,
    columns: [
        { field: 'ModDetailId', label: 'Primary Key', type: 'number' },
        { field: 'DisplayField', label: 'Master Modified' },
        { field: 'TableName', label: 'Table Name', filterable: false, sortable: false },
        { field: 'ActionTypeId', label: 'Type', type: 'select', width: 200, lookup: 'Type' },
        { field: 'ColumnName', label: 'Field Name' },
        { field: 'FinalOldValue', label: 'Old Value', filterable: false, sortable: false },
        { field: 'FinalNewValue', label: 'New Value', filterable: false, sortable: false }
    ]
});

export default NewHistoryModel;